var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReady
    ? _c(
        "div",
        {
          staticClass: "page-body content-inner",
          attrs: { "data-content-width": "wide" },
        },
        [
          _c("div", { staticClass: "page-header typography" }, [
            _c("h1", [_vm._v(_vm._s(_vm.t("app-program-settings")))]),
          ]),
          _vm._v(" "),
          _vm.isReady
            ? _c(
                "form",
                {
                  staticClass: "standard-form-style",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.save()
                    },
                  },
                },
                [
                  _c(
                    "table",
                    { staticClass: "vuetable ui-table fixed clickable-rows" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(_vm._s(_vm.t("app-name")))]),
                          _vm._v(" "),
                          _c("th"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tbody", [
                        _c(
                          "tr",
                          {
                            on: {
                              click: function ($event) {
                                _vm.program.settings.NQMS =
                                  !_vm.program.settings.NQMS
                              },
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(_vm.t("app-nqms")))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "div",
                                { staticClass: "md-style-scoped" },
                                [
                                  _c("md-switch", {
                                    model: {
                                      value: _vm.program.settings.NQMS,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.program.settings,
                                          "NQMS",
                                          $$v
                                        )
                                      },
                                      expression: "program.settings.NQMS",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "tr",
                          {
                            on: {
                              click: function ($event) {
                                _vm.program.settings.ADA =
                                  !_vm.program.settings.ADA
                              },
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(_vm.t("app-ada")))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "div",
                                { staticClass: "md-style-scoped" },
                                [
                                  _c("md-switch", {
                                    model: {
                                      value: _vm.program.settings.ADA,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.program.settings,
                                          "ADA",
                                          $$v
                                        )
                                      },
                                      expression: "program.settings.ADA",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("program-actions", {
                    attrs: { active: "settings", program: _vm.program },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }